/** @file buildUrl: the client base URL plus a path and its query string. */
import { PRODUCTION_URL } from '../constants/productionUrl';
import type { ClientOptions, RequestInput } from './clientOptions';

function queryString(query: RequestInput['query']): string {
  const parts = Object.entries(query ?? {})
    .filter((e): e is [string, string | number] => e[1] !== undefined)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

/** `opts.url` (default `PRODUCTION_URL`, trailing slashes stripped) + `path` + query; a full `http(s)://` path is kept. */
export function buildUrl(opts: Pick<ClientOptions, 'url'>, input: Pick<RequestInput, 'path' | 'query'>): string {
  const base = /^https?:\/\//.test(input.path) ? '' : (opts.url ?? PRODUCTION_URL).replace(/\/+$/, '');
  return `${base}${input.path}${queryString(input.query)}`;
}
